export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/index.js